import {BasicButton, WhiteBgButton} from '@packages/ui';
import {useRouter} from 'next/router';
import {LOGIN, REMIND_PASS} from '../../../../../config/constants/routes';
import isAppWebView from '../../../../../config/isAppWebView';
import {QUERY_PARAMS_FOR_REDIRECT_FROM_LOGIN_PAGE} from '../../../../../core/entities/login/constants';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {getMailAuthLinkWithParamsHooks} from '../../../../../shared/services/getMailAuthLinkWithParamsHooks';

export const LoginNavigationForLimitedPost: React.FC = () => {
  const router = useRouter();
  const mailAuthLink = getMailAuthLinkWithParamsHooks({});

  return (
    <div className="mt-16 mb-32 border-b-[1px] border-line border-collapse">
      <p className="text-base text-black-1 leading">...</p>
      <div className="w-full p-32">
        <p className="text-md text-black-1 leading font-bold">
          会員登録して全ての内容を見る
        </p>
        <p className="text-base text-black-1 leading mt-12">
          続きは外資就活ドットコム会員の方のみご覧いただけます。
          <br />
          外資就活ドットコムはグローバルに活躍したい学生向けの就職活動支援サイトです。会員登録をすると、「先輩のES・体験記」や「トップ企業の募集情報リスト」など、就活に役立つ情報をご覧いただけます。
        </p>
        <div className="mt-24">
          <div className="pb-16 mb-24 border-b-[1px] border-line border-collapse">
            <WhiteBgButton
              onClick={async () => {
                const path = `${LOGIN}?${QUERY_PARAMS_FOR_REDIRECT_FROM_LOGIN_PAGE}=${router.asPath}`;
                if (isAppWebView()) {
                  location.href = path;
                } else {
                  return router.push(path);
                }
              }}
              label={'ログイン'}
              isPrimary={false}
              className="w-full"
            />
            <div className="mt-16 block">
              <CommonLink
                href={REMIND_PASS}
                className="text-base text-link leading pc:hover:underline"
              >
                パスワードを忘れた場合はこちら
              </CommonLink>
            </div>
          </div>
          <BasicButton
            onClick={async () => {
              if (isAppWebView()) {
                location.href = mailAuthLink;
              } else {
                return router.push(mailAuthLink);
              }
            }}
            isLarge={true}
            isPrimary={true}
          >
            新規会員登録をする
          </BasicButton>
        </div>
      </div>
    </div>
  );
};
